import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { CHECKOUT_FEATURE } from './checkout.state';
import { customReducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { effects } from './effects';

import { CheckoutCartsEffectsService } from './effects/checkout-carts-effects.service';
import { CheckoutDeliveryModesConnector } from '@spartacus/checkout/base/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(CHECKOUT_FEATURE, customReducers),
    EffectsModule.forFeature(effects),
  ],
  providers: [
    CheckoutCartsEffectsService,
    CheckoutDeliveryModesConnector
  ]
})
export class CheckoutStoreModule { }
